function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

export var createNewChildComponent = function createNewChildComponent(parent, Component) {
  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var bvEventRoot = parent.$root ? parent.$root.$options.bvEventRoot || parent.$root : null;
  return new Component(_objectSpread(_objectSpread({}, config), {}, {
    parent: parent,
    bvParent: parent,
    bvEventRoot: bvEventRoot
  }));
};


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/esm/utils/create-new-child-component.js
// module id = 60
// module chunks = 0